import { render, staticRenderFns } from "./ProjectDashboardTab.vue?vue&type=template&id=7ff381d8"
import script from "./ProjectDashboardTab.vue?vue&type=script&lang=ts"
export * from "./ProjectDashboardTab.vue?vue&type=script&lang=ts"
import style0 from "./ProjectDashboardTab.vue?vue&type=style&index=0&id=7ff381d8&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports